import axios from '../utils/axios';

export default function getBlacklistedSeeker(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/blacklisted`, { params });
};
